import React from "react";
import TextField from "./TextField";
import {RiLoaderFill} from "react-icons/ri";

const OtpModal = ({visible, toggleModal, setOtp, accountDetails, getOtp, isSubmitting, submitResponse}) => {
    const Phonenumber = accountDetails?.AccountDetails?.Phonenumber ?? '';
    const masked = [...Phonenumber].map((x, index) => index < 7 ? "*" : x).join("");
  
    

    return (
        <div
            className={`${visible ? "block" : "hidden"} fixed inset-0 flex items-center justify-center z-30`}>
            <div className="absolute bg-black/20 w-screen h-screen cursor-pointer"></div>

            <div className="px-4">
                <div
                    className="relative bg-white rounded rounded-xl shadow-lg p-4 flex flex-col items-center justify-center">

                    {!isSubmitting && submitResponse?.Status !== '1' &&
                        (<div className="flex flex-col items-start w-full">
                            <span className="text-xs text-slate-600 py-2">An OTP has been sent to {masked}</span>
                            <div className="flex flex-col items-center w-full">
                                <TextField label="Enter OTP" onChange={e => setOtp(e.target.value)}
                                           autoComplete="one-time-code"
                                           type="text"
                                           name="auth-token"
                                           inputMode="numeric"
                                           maxLength="4"
                                           pattern="[0-9]*" required/>
                                <div className="flex flex-col items-center mt-3">
                                    <span className="text-xs block text-slate-600">if you've not received OTP, click to resend to receive another one </span>
                                    <button type="button" onClick={() => getOtp()}
                                            className="text-sm border px-1 py-1.5 rounded block text-white bg-[#dd4f05] mt-2 w-full"> resend
                                    </button>
                                </div>
                            </div>
                        </div>)}

                    {isSubmitting && <RiLoaderFill className="animate-spin h-10 w-10 ml-3"/>}

                    {submitResponse?.Status === '1' && (
                        <div className="w-[80vw] sm:w-72 flex flex-col items-center">
                        <span className="block text-xl ">Completed</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 stroke-green-600" fill="none"
                             viewBox="0 0 24 24"
                             stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/>
                        </svg>
                        <div className="w-full">
                            <button type="button"
                                    className="p-2 w-full block rounded-md border text-xl bg-[#dd4f05] text-white"
                                    onClick={() => window.location.reload()}> Ok
                            </button>
                        </div>
                    </div>)}

                    <button
                        className="absolute -top-3 -right-3 h-8 w-8 rounded-full bg-red-600 text-white inline-flex items-center justify-center"
                        onClick={toggleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
            </div>

        </div>
    );
};

export default OtpModal;